// return custom styled component of data grid
import { DataGrid } from '@mui/x-data-grid';
import { useTheme } from '@mui/material';
import { useState } from 'react';

export default function DataGridCustom(props) {
  const theme = useTheme();

  return (
    <DataGrid
      {...props}
      sx={{
        width: '100%',
        border: '1px solid theme.palette.primary[100]',
        borderRadius: '5px',

        // style the data grid based on the theme
        '& .MuiDataGrid-row': {
          backgroundColor: theme.palette.primary[900],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-cell': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnsContainer': {
          backgroundColor: theme.palette.primary[900],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeader': {
          backgroundColor: theme.palette.primary[700],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitleContainer': {
          color: theme.palette.secondary[100],
        },

        // on hover
        '& .MuiDataGrid-row:hover': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-cell:hover': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnsContainer:hover': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeader:hover': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitle:hover': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitleContainer:hover': {
          color: theme.palette.secondary[100],
        },

        // on selected
        '& .MuiDataGrid-row.Mui-selected': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-cell.Mui-selected': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnsContainer.Mui-selected': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeader.Mui-selected': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitle.Mui-selected': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitleContainer.Mui-selected': {
          color: theme.palette.secondary[100],
        },

        // on focus
        '& .MuiDataGrid-row:focus': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-cell:focus': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnsContainer:focus': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeader:focus': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitle:focus': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitleContainer:focus': {
          color: theme.palette.secondary[100],
        },

        // on active
        '& .MuiDataGrid-row:active': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-cell:active': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnsContainer:active': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeader:active': {
          backgroundColor: theme.palette.primary[800],
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitle:active': {
          color: theme.palette.secondary[100],
        },
        '& .MuiDataGrid-columnHeaderTitleContainer:active': {
          color: theme.palette.secondary[100],
        },
      }}
    />
  );
}
